module.exports = "<div>\n    <menu params=\"{{params}}\"></menu>\n    <topic-list params=\"{{params}}\"></topic-list>\n    <article params=\"{{params}}\"></article>\n  </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
 ** module id = 30
 ** module chunks = 0
 **/